import { render } from "./nq-address.vue?vue&type=template&id=5b493886&scoped=true"
import script from "./nq-address.vue?vue&type=script&lang=js"
export * from "./nq-address.vue?vue&type=script&lang=js"

import "./nq-address.vue?vue&type=style&index=0&id=5b493886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b493886"]])

export default __exports__